// in src/OutOfHomeCampaign/CreateDashboard.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';

class CreateDashboard extends Component {

    handleClick = () => {
        const {record} = this.props;

        const outmooveId = record.outmoove_campaign
            ? record.outmoove_campaign.split('/').pop()
            : '';

        const reportId = 'b0dde631-d003-49a6-8227-98b626935842';
        const firstWord = (record.name && typeof record.name === 'string' ? record.name.trim().split(" ")[0] : '');
        const connectorName = firstWord + ' ' + new Date().getFullYear();
        const reportName = 'DOOH Dashboard - ' + connectorName;

        const totalsNr = '1a. OOH - GoogleDataStudio connector - Locations - '
        const totals = 'ds47';
        const totalsImplementationId = 'AKfycbzizahB65T_hmQQfN7DnEBEFEJcpJSSz-DgrFU_5EJq0WcLht_SBXLP2OP71PjN0IiKGA';
        const totalsUrl = `&ds.${totals}.datasourceName=${totalsNr} ${connectorName}&ds.${totals}.connector=community&ds.${totals}.connectorId=${totalsImplementationId}&ds.${totals}.uuid=${record.originId}`;

        const totals2Nr = '1b. OOH - GoogleDataStudio connector - Locations - '
        const totals2 = 'ds61';
        const totals2ImplementationId = 'AKfycbzizahB65T_hmQQfN7DnEBEFEJcpJSSz-DgrFU_5EJq0WcLht_SBXLP2OP71PjN0IiKGA';
        const totals2Url = `&ds.${totals2}.datasourceName=${totals2Nr} ${connectorName}&ds.${totals2}.connector=community&ds.${totals2}.connectorId=${totals2ImplementationId}&ds.${totals2}.uuid=${record.originId}`;

        const resultsNr = '2. OOH - GoogleDataStudio connector - Results - '
        const results = 'ds48';
        const resultsImplementationId = 'AKfycbyZhzqs5l63duxSfcJuC7k3OUEtgMhIqxVcinJj7sIE4riipMHR7nCgfOgPyC1edIFY';
        const resultsUrl = `&ds.${results}.datasourceName=${resultsNr} ${connectorName}&ds.${results}.connector=community&ds.${results}.connectorId=${resultsImplementationId}&ds.${results}.uuid=${record.originId}`;

        const spotsNr = '3. OOH - GoogleDataStudio connector - Images - '
        const spots = 'ds60';
        const spotsImplementationId = 'AKfycbzMcU5P_nGPOtV14c3n_PFBAWuXD7jriEkoqGYEZgwmVl01yilg-K0EqwJdCLr-d9SW';
        const spotsUrl = `&ds.${spots}.datasourceName=${spotsNr} ${connectorName}&ds.${spots}.connector=community&ds.${spots}.connectorId=${spotsImplementationId}&ds.${spots}.uuid=${record.originId}`;

        const doohLocationsNr = '4. DOOH - GoogleDataStudio connector - Locations - '
        const doohLocations = 'ds114';
        const doohLocationsImplementationId = 'AKfycbwWQ-n2J8csH6mDDbhnN0OY1IS-c7iQWgZj-pBsPdEK3UEYDrzOzXIC893qVdw3chw7UA';
        const doohLocationsUrl = `&ds.${doohLocations}.datasourceName=${doohLocationsNr} ${connectorName}&ds.${doohLocations}.connector=community&ds.${doohLocations}.connectorId=${doohLocationsImplementationId}&ds.${doohLocations}.campaignId=${outmooveId}`;

        const doohResultsNr = '5. DOOH - GoogleDataStudio connector - Results - '
        const doohResults = 'ds42';
        const doohResultsImplementationId = 'AKfycbzKB_hu4YrRgOL1DVUvHqWCIHS9Ct8wL94aEpR0wtMalNvhvA7L3DW9Ihw84HR0sj5a';
        const doohResultsUrl = `&ds.${doohResults}.datasourceName=${doohResultsNr} ${connectorName}&ds.${doohResults}.connector=community&ds.${doohResults}.connectorId=${doohResultsImplementationId}&ds.${doohResults}.campaignId=${outmooveId}`;

        const doohCampaignsNr = '6. DOOH - GoogleDataStudio connector - Campaigns - '
        const doohCampaigns = 'ds113';
        const doohCampaignsImplementationId = 'AKfycby6PGXwLTzhToP2pE9g_NwtEMABFcD8QpqIIe3LXzULE-OBOMl2E8FZEpkWggiwtAU';
        const doohCampaignsUrl = `&ds.${doohCampaigns}.datasourceName=${doohCampaignsNr} ${connectorName}&ds.${doohCampaigns}.connector=community&ds.${doohCampaigns}.connectorId=${doohCampaignsImplementationId}&ds.${doohCampaigns}.campaignId=${outmooveId}`;

        window.open(`https://lookerstudio.google.com/reporting/create?c.reportId=${reportId}&r.reportName=${reportName}${totalsUrl}${totals2Url}${resultsUrl}${spotsUrl}${doohResultsUrl}${doohCampaignsUrl}${doohLocationsUrl}`, '_blank');
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <FileCopyIcon /> &nbsp; New dashboard
        </Button>;
    }
}

CreateDashboard.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(CreateDashboard);